// frontend/src/pages/Register.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LoginDesign.css";

export default function Register() {
  const navigate = useNavigate();

  const [pseudo, setPseudo] = useState("");
  const [email, setEmail] = useState("");
  const [bio, setBio] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const [profilePic, setProfilePic] = useState(null);
  const [video, setVideo] = useState(null);
  const [videoTitle, setVideoTitle] = useState("");

  const [error, setError] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirm) {
      setError("Les mots de passe ne correspondent pas !");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("pseudo", pseudo);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("bio", bio);

      if (profilePic) formData.append("profilePic", profilePic);
      if (video) formData.append("video", video);

      // ✅ NOM CORRECT
      formData.append("video_title", videoTitle);

      // 🔍 DEBUG (temporaire mais utile)
      console.log("===== FORM DATA ENVOYÉ =====");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      console.log("============================");

      const res = await axios.post("/auth/register", formData);

      if (!res.data || !res.data.success) {
        setError("Erreur lors de la création du compte");
        return;
      }

      // ✅ le backend ne renvoie pas le pseudo → on le connaît déjà
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          id: res.data.userId,
          pseudo: pseudo,
          email: email,
        })
      );

      navigate(`/user/${pseudo}`);
    } catch (err) {
      console.error("Erreur register :", err);
      setError(
        err.response?.data?.error ||
        "Erreur serveur lors de l'inscription"
      );
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-left">
          <img src="/assets/evo-logo.png" alt="logo" className="login-logo" />
          <h2>Créer un compte</h2>

          <form onSubmit={handleRegister} className="login-form">
            <input
              type="email"
              placeholder="Adresse e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="text"
              placeholder="Pseudo"
              value={pseudo}
              onChange={(e) => setPseudo(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <input
              type="password"
              placeholder="Confirmer le mot de passe"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />

            <textarea
              placeholder="Biographie"
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              rows="3"
            />

            <label>📸 Photo de profil</label>
            <input type="file" onChange={(e) => setProfilePic(e.target.files[0])} />

            <label>🎬 Vidéo de présentation</label>
            <input type="file" onChange={(e) => setVideo(e.target.files[0])} />

            <input
              type="text"
              placeholder="Titre de votre vidéo"
              value={videoTitle}
              onChange={(e) => setVideoTitle(e.target.value)}
            />

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="login-btn">
              Créer mon compte
            </button>
          </form>

          <p className="login-switch">
            Déjà inscrit ?{" "}
            <span onClick={() => navigate("/login")}>
              Se connecter
            </span>
          </p>
        </div>

        <div className="login-right">
          <h1>BIENVENUE ✨</h1>
          <p>Rejoins l’aventure EVO-LIVE ! 🎬</p>
        </div>
      </div>
    </div>
  );
}
